export enum TrendIntervalType {
  FourWeeks = 'FourWeeks',
  EightWeeks = 'EightWeeks',
  Custom = 'Custom',
  PreviousYearFourWeeks = 'PreviousYearFourWeeks',
  PreviousYearEightWeeks = 'PreviousYearEightWeeks',
  PreviousYearCustom = 'PreviousYearCustom'
}
